import { Loadable } from '../../Loadable';

export const AsyncAddTextmunicationConfig = Loadable(() => import('./Add'));
export const AsyncEditTextmunicationConfig = Loadable(() => import('./Edit'));
export const AsyncTextmunicationConfigList = Loadable(() => import('./List'));
